import React, { useState } from 'react';
import { FiCheck } from 'react-icons/fi';

const courseFeatures = [
   { icon: <FiCheck />, text: 'Become a UX designer.' },
   { icon: <FiCheck />, text: 'You will be able to add UX designer to your CV' },
   { icon: <FiCheck />, text: 'Become a UI designer.' },
   { icon: <FiCheck />, text: 'Build & test a full website design.' },
   { icon: <FiCheck />, text: 'Create your first UX brief & persona.' },
   { icon: <FiCheck />, text: 'How to use premade UI kits.' },
   { icon: <FiCheck />, text: 'Create quick wireframes.' },
   { icon: <FiCheck />, text: 'Downloadable exercise files' },
   { icon: <FiCheck />, text: 'Build a UX project from beginning to end.' },
   { icon: <FiCheck />, text: 'Learn to design websites & mobile phone apps.' },
   { icon: <FiCheck />, text: 'All the techniques used by UX professionals' },
   { icon: <FiCheck />, text: 'You will be able to talk correctly with other UX design.' }
];

function Overview({ course }) {
   const [showFullDescription, setShowFullDescription] = useState(false);

   const toggleDescription = () => {
      setShowFullDescription(!showFullDescription);
   };

   return (
      <div>
         <h4 className="text-lg font-medium text-dark-1 dark:text-white">Description</h4>

         <div className="relative mt-6">
            <div
               className={`text-gray-600 dark:text-gray-300 transition-all duration-500 ease-in-out
                  overflow-hidden ${showFullDescription ? 'max-h-[1000px]' : 'max-h-[180px]'}`}
            >
               <p>
                  {course.description}
               </p>
            </div>

            {/* Overlay de dégradé */}
            {!showFullDescription && (
               <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent
               dark:from-dark-5 dark:to-transparent pointer-events-none"></div>
            )}
         </div>

         <button
            onClick={toggleDescription}
            className="text-purple-1 dark:text-purple-1 font-medium underline mt-2 flex items-center
            dark:hover:text-purple-300 transition-colors"
         >
            {showFullDescription ? (
               <>
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                  </svg>
                  Show Less
               </>
            ) : (
               <>
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                  Show More
               </>
            )}
         </button>

         <div className="mt-12">
            <h4 className="text-xl font-semibold text-dark-1 dark:text-white mb-6">What you'll learn</h4>
            <div className="grid md:grid-cols-2 gap-6">
               {courseFeatures.slice(0, 6).map((feature, index) => (
                  <div key={index} className="flex items-center">
                     <div className="flex justify-center items-center w-5 h-5 rounded-full border
                     border-gray-300 dark:border-gray-600 mr-3 text-purple-1">
                        {feature.icon}
                     </div>
                     <span className="text-gray-700 dark:text-gray-300">{feature.text}</span>
                  </div>
               ))}
            </div>
            <div className="grid md:grid-cols-2 gap-6 mt-6">
               {courseFeatures.slice(6).map((feature, index) => (
                  <div key={index} className="flex items-center">
                     <div className="flex justify-center items-center w-5 h-5 rounded-full border border-gray-300
                     dark:border-gray-600 mr-3 text-purple-1">
                        {feature.icon}
                     </div>
                     <span className="text-gray-700 dark:text-gray-300">{feature.text}</span>
                  </div>
               ))}
            </div>
         </div>

         <div className="mt-12">
            <h4 className="text-xl font-semibold text-dark-1 dark:text-white">Requirements</h4>
            <ul className="mt-6 space-y-4 text-gray-600 dark:text-gray-300 list-disc pl-5">
               <li>You will need a copy of Adobe XD 2019 or above. A free trial can be downloaded from Adobe.</li>
               <li>No previous design experience is needed.</li>
               <li>No previous Adobe XD skills are needed.</li>
            </ul>
         </div>
      </div>
   );
}

export default Overview;